import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { Tabs, Tab, Paper, Box } from '@mui/material';
import SystemParametersPage from './SystemParametersPage';
import UserImapsPage from './UserImapsPage';
import Header from '../../Components/ContactListWrapper/EntriesWrapper/Header';
import { FullSizeColumn } from '../../Components/FlexBox';

const useStyles = () => ({
  defaultLayoutStyle: {
    height: '100%',
    overflow: 'hidden',
  },
});

const SettingsPage = function SettingsPage() {
  const intl = useIntl();
  const classes = useStyles();

  const [tab, setTab] = useState('SYSTEM_PARAMETERS');
  const [searchedValue, setSearchedValue] = useState('');

  const handleSearchValue = (newSearch) => {
    const { searchBox } = newSearch || {};
    setSearchedValue(searchBox || '');
  };

  const handleChangeTab = (event, newTab) => {
    handleSearchValue(null);
    setTab(newTab);
  };

  return (
    <div style={classes.defaultLayoutStyle}>
      <Paper id="settings-box" sx={{ height: '100%' }}>
        <FullSizeColumn>
          <Header
            title="SETTINGS"
            setSearchValues={handleSearchValue}
            hideSorting
            hideFilters
            hideExportExcel
          />
          <Box
            sx={{
              borderBottom: 1,
              borderColor: 'divider',
            }}
          >
            <Tabs
              variant="fullWidth"
              value={tab}
              onChange={handleChangeTab}
              fontSize="0.9rem"
            >
              <Tab
                value="SYSTEM_PARAMETERS"
                label={intl.messages.SYSTEM_PARAMETERS}
              />
              <Tab
                value="IMAPS_CONFIGURATION"
                label={intl.messages.IMAPS_CONFIGURATION}
              />
            </Tabs>
          </Box>
          {tab === 'SYSTEM_PARAMETERS' && (
            <SystemParametersPage searchedValue={searchedValue} />
          )}
          {tab === 'IMAPS_CONFIGURATION' && (
            <UserImapsPage searchedValue={searchedValue} />
          )}
        </FullSizeColumn>
      </Paper>
    </div>
  );
};
export default SettingsPage;
